(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels"] && !Shopify.designMode) return;
  try {
    
  class ChronobazarReels {
    constructor(root) {
      this.root = root;
      this.list = root.querySelector('[data-reels-list]');
      this.cards = Array.from(root.querySelectorAll('[data-reel-open]'));
      this.viewer = root.querySelector('[data-reels-viewer]');
      this.track = root.querySelector('[data-reels-track]');
      this.slides = Array.from(root.querySelectorAll('[data-reels-slide]'));
      if (!this.list || !this.viewer || !this.track || this.cards.length === 0) return;
      if (this.cards.length !== this.slides.length) return;

      this.prevButton = root.querySelector('[data-reels-prev]');
      this.nextButton = root.querySelector('[data-reels-next]');
      this.soundButton = root.querySelector('[data-reels-sound]');
      this.stepButtons = Array.from(root.querySelectorAll('[data-reels-step]'));

      this.current = -1;
      this.withSound = true;
      this.onScreen = new Set();
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.cartEvents = null;

      // Loaded up front so a submit can decide synchronously whether to take
      // over; if the module never arrives, the form posts to /cart/add itself.
      import('@shopify/events')
        .then((module) => { this.cartEvents = module; })
        .catch(() => {});

      this.observeCards();
      this.observeSlides();
      this.bind();
      this.syncArrows();
    }

    videoOf(element) {
      return element.querySelector('video');
    }

    playMuted(video) {
      video.muted = true;
      video.play().catch(() => {});
    }

    // Clips autoplay muted only while most of the card is visible, so a row of
    // reels never has off-screen videos downloading and decoding.
    observeCards() {
      if (this.reduceMotion) return;
      this.cardObserver = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) this.onScreen.add(target);
          else this.onScreen.delete(target);

          if (isIntersecting && !this.viewer.open) this.playMuted(target);
          else target.pause();
        });
      }, { threshold: 0.6 });

      this.cards.forEach((card) => this.cardObserver.observe(this.videoOf(card)));
    }

    observeSlides() {
      this.slideObserver = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting && this.viewer.open) this.activate(this.slides.indexOf(target));
        });
      }, { root: this.track, threshold: 0.6 });

      this.slides.forEach((slide) => this.slideObserver.observe(slide));
    }

    bind() {
      this.cards.forEach((card, index) => card.addEventListener('click', () => this.open(index)));
      this.prevButton?.addEventListener('click', () => this.scrollRow(-1));
      this.nextButton?.addEventListener('click', () => this.scrollRow(1));
      this.list.addEventListener('scroll', () => this.syncArrows(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.syncArrows());
      this.resizeObserver.observe(this.list);

      this.root.querySelector('[data-reels-close]')?.addEventListener('click', () => this.viewer.close());
      this.soundButton?.addEventListener('click', () => this.setSound(!this.withSound));
      this.stepButtons.forEach((button) => {
        button.addEventListener('click', () => this.step(Number(button.dataset.reelsStep)));
      });

      this.viewer.addEventListener('close', () => this.onClose());
      this.viewer.addEventListener('keydown', (event) => this.onKey(event));
      // The dark space beside the clip belongs to the slide, not the stage.
      this.viewer.addEventListener('click', (event) => {
        if (event.target.matches('[data-reels-slide]')) this.viewer.close();
      });

      this.slides.forEach((slide) => {
        slide.querySelector('[data-reels-toggle]')?.addEventListener('click', () => this.togglePlay(slide));
        slide.querySelector('.cbz-reels-slide__form')?.addEventListener('submit', (event) => this.addToCart(event));
      });
    }

    open(index) {
      this.cards.forEach((card) => this.videoOf(card).pause());
      document.documentElement.classList.add('cbz-reels-lock');
      this.viewer.showModal();
      this.track.scrollTo({ top: index * this.track.clientHeight, behavior: 'instant' });
      this.activate(index);
    }

    activate(index) {
      if (index < 0 || index === this.current) return;

      const previous = this.slides[this.current];
      if (previous) this.videoOf(previous).pause();

      this.current = index;
      const slide = this.slides[index];
      const video = this.videoOf(slide);
      video.currentTime = 0;
      slide.classList.remove('is-paused');
      slide.querySelector('[data-reels-toggle]')?.setAttribute('aria-label', 'Pause reel');
      this.playWithSound(video);

      this.stepButtons.forEach((button) => {
        const target = index + Number(button.dataset.reelsStep);
        button.disabled = target < 0 || target >= this.slides.length;
      });
    }

    playWithSound(video) {
      video.muted = !this.withSound;
      video.play().catch((error) => {
        // Sound needs a user gesture, and a swipe does not always count as one.
        if (error.name !== 'NotAllowedError' || video.muted) return;
        this.setSound(false);
        video.play().catch(() => {});
      });
    }

    setSound(on) {
      this.withSound = on;
      this.soundButton?.setAttribute('aria-pressed', String(on));
      const slide = this.slides[this.current];
      if (slide) this.videoOf(slide).muted = !on;
    }

    togglePlay(slide) {
      const video = this.videoOf(slide);
      const toggle = slide.querySelector('[data-reels-toggle]');
      const resume = video.paused;

      if (resume) this.playWithSound(video);
      else video.pause();

      slide.classList.toggle('is-paused', !resume);
      toggle?.setAttribute('aria-label', resume ? 'Pause reel' : 'Play reel');
    }

    step(delta) {
      const target = Math.min(Math.max(this.current + delta, 0), this.slides.length - 1);
      this.track.scrollTo({
        top: target * this.track.clientHeight,
        behavior: this.reduceMotion ? 'instant' : 'smooth',
      });
    }

    onKey(event) {
      if (event.key === 'ArrowDown' || event.key === 'PageDown') {
        event.preventDefault();
        this.step(1);
      } else if (event.key === 'ArrowUp' || event.key === 'PageUp') {
        event.preventDefault();
        this.step(-1);
      }
    }

    onClose() {
      this.slides.forEach((slide) => this.videoOf(slide).pause());
      this.current = -1;
      document.documentElement.classList.remove('cbz-reels-lock');
      if (!this.reduceMotion) this.onScreen.forEach((video) => this.playMuted(video));
    }

    scrollRow(direction) {
      this.list.scrollBy({
        left: direction * this.list.clientWidth * 0.8,
        behavior: this.reduceMotion ? 'instant' : 'smooth',
      });
    }

    syncArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const room = this.list.scrollWidth - this.list.clientWidth;
      const overflow = room > 1;
      this.prevButton.hidden = !overflow || this.list.scrollLeft <= 1;
      this.nextButton.hidden = !overflow || this.list.scrollLeft >= room - 1;
    }

    // Mirrors the theme's product form: announce the add with a pending promise,
    // then settle it with the refreshed cart so every cart listener updates.
    async addToCart(event) {
      const events = this.cartEvents;
      if (!events) return;
      event.preventDefault();

      const form = event.currentTarget;
      const button = form.querySelector('[type="submit"]');
      const label = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      const body = new FormData(form);
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'), (el) => el.dataset.sectionId)
        .filter(Boolean);
      if (sectionIds.length > 0) body.append('sections', sectionIds.join(','));

      const deferred = events.CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new events.CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(body.get('id')), quantity: 1 }],
        promise: deferred.promise,
      }));

      const routes = typeof Theme !== 'undefined' ? Theme.routes : { cart_add_url: '/cart/add.js', cart_url: '/cart' };

      try {
        const added = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        }).then((response) => response.json());
        const cart = await fetch(`${routes.cart_url}.json`).then((response) => response.json());
        const failed = Boolean(added.status);

        deferred.resolve({
          cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'cbz-reels', itemCount: 1, sections: added.sections, didError: failed },
        });
        this.flash(button, label, failed ? added.description || added.message || 'Could not add' : 'Added ✓');
      } catch (error) {
        deferred.reject(error);
        this.flash(button, label, 'Try again');
      }
    }

    flash(button, label, message) {
      button.textContent = message;
      window.setTimeout(() => {
        button.textContent = label;
        button.disabled = false;
      }, 2200);
    }

    destroy() {
      this.cardObserver?.disconnect();
      this.slideObserver?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.viewer?.open) this.viewer.close();
    }
  }

  const reelInstances = new WeakMap();

  function initReels(scope) {
    (scope || document).querySelectorAll('[data-reels-root]').forEach((root) => {
      if (reelInstances.has(root)) return;
      reelInstances.set(root, new ChronobazarReels(root));
    });
  }

  document.addEventListener('DOMContentLoaded', () => initReels());
  document.addEventListener('shopify:section:load', (event) => initReels(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-reels-root]').forEach((root) => {
      reelInstances.get(root)?.destroy();
      reelInstances.delete(root);
    });
  });
  if (document.readyState !== 'loading') initReels();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class ChronobazarQuotes {
    constructor(root) {
      this.viewport = root.querySelector('[data-quotes-viewport]');
      this.track = root.querySelector('[data-quotes-track]');
      if (!this.viewport || !this.track || this.track.children.length === 0) return;

      this.speed = Number(root.dataset.quotesSpeed || 40) / 1000;
      this.paused = false;
      this.last = null;

      this.cloneRun();
      this.bind();
      this.frame = requestAnimationFrame(this.step);
    }

    // The run is duplicated so scrollLeft can wrap at the halfway mark without
    // the reader ever seeing the list restart.
    cloneRun() {
      this.originalCount = this.track.children.length;
      Array.from(this.track.children).forEach((card) => {
        const copy = card.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
        this.track.appendChild(copy);
      });
    }

    bind() {
      const hold = () => { this.paused = true; };
      const release = () => { this.paused = false; };

      this.viewport.addEventListener('pointerenter', hold);
      this.viewport.addEventListener('pointerleave', release);
      this.viewport.addEventListener('pointerdown', hold);
      window.addEventListener('pointerup', release);
      this.viewport.addEventListener('focusin', hold);
      this.viewport.addEventListener('focusout', release);
      // A tab in the background gets no frames; without this the elapsed delta
      // on return would be seconds long and jump the strip.
      document.addEventListener('visibilitychange', () => { this.last = null; });
    }

    step = (now) => {
      this.frame = requestAnimationFrame(this.step);
      if (this.last === null) { this.last = now; return; }

      const elapsed = now - this.last;
      this.last = now;
      if (this.paused) return;

      const half = this.viewport.scrollWidth / 2;
      let next = this.viewport.scrollLeft + this.speed * elapsed;
      if (next >= half) next -= half;
      this.viewport.scrollLeft = next;
    };

    destroy() {
      cancelAnimationFrame(this.frame);
    }
  }

  const instances = new WeakMap();

  function initQuotes(scope) {
    (scope || document).querySelectorAll('[data-quotes-root]').forEach((root) => {
      if (instances.has(root)) return;
      // Auto-advance is motion the reader did not ask for; honour the setting.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      instances.set(root, new ChronobazarQuotes(root));
    });
  }

  document.addEventListener('DOMContentLoaded', () => initQuotes());
  document.addEventListener('shopify:section:load', (event) => initQuotes(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-quotes-root]').forEach((root) => {
      const held = instances.get(root);
      if (held) { held.destroy(); instances.delete(root); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-showcase"] && !Shopify.designMode) return;
  try {
    
  class ChronobazarShowcase {
    constructor(root) {
      this.root = root;
      this.image = root.querySelector('[data-showcase-image]');
      this.price = root.querySelector('[data-showcase-price]');
      this.input = root.querySelector('[data-showcase-variant-input]');
      this.submit = root.querySelector('[data-showcase-submit]');
      this.submitText = root.querySelector('[data-showcase-submit-text]');
      this.thumbs = Array.from(root.querySelectorAll('[data-showcase-thumb]'));
      this.defaultLabel = this.submitText ? this.submitText.textContent.trim() : 'Add to cart';

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.select(thumb));
      });
    }

    select(thumb) {
      const { variantId, variantPrice, variantImage, variantImageSrcset, variantAvailable } = thumb.dataset;
      const available = variantAvailable === 'true';

      this.thumbs.forEach((other) => {
        const isTarget = other === thumb;
        other.classList.toggle('is-active', isTarget);
        other.setAttribute('aria-checked', String(isTarget));
      });

      if (this.input && variantId) this.input.value = variantId;
      if (this.price && variantPrice) this.price.textContent = variantPrice;

      if (this.submit) {
        this.submit.disabled = !available;
        if (this.submitText) {
          this.submitText.textContent = available ? this.defaultLabel : 'Sold out';
        }
      }

      if (this.image && variantImage) this.swapImage(variantImage, variantImageSrcset);
    }

    swapImage(src, srcset) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const apply = () => {
        this.image.src = src;
        if (srcset) this.image.srcset = srcset;
        this.image.classList.remove('is-swapping');
      };

      if (reduceMotion) {
        apply();
        return;
      }

      this.image.classList.add('is-swapping');
      // Decode before revealing so the cross-fade never lands on a half-painted frame.
      const preload = new Image();
      preload.onload = apply;
      preload.onerror = apply;
      preload.src = src;
    }
  }

  function initChronobazarShowcases() {
    document.querySelectorAll('.showcase').forEach((root) => {
      if (root.dataset.showcaseReady) return;
      root.dataset.showcaseReady = 'true';
      new ChronobazarShowcase(root);
    });
  }

  document.addEventListener('DOMContentLoaded', initChronobazarShowcases);
  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', initChronobazarShowcases);
  if (document.readyState !== 'loading') initChronobazarShowcases();

  } catch(e) { console.error(e); }
})();
})();
